import type { ComponentProps } from "react";

import { Card2 } from "@/ui2/atoms/Card";
import { cn } from "@/lib/helpers/cn";
import { Heading2 } from "@/ui2/atoms/Heading";

type DashboardCardProps = {
  Actions?: React.ReactNode;
  classNameChildren?: string;
  classNameCopy?: string;
  copy?: string;
  headingProps?: ComponentProps<typeof Heading2>;
  isFullBleed?: boolean;
  rawChildren?: boolean;
  title?: React.ReactNode;
} & Omit<ComponentProps<typeof Card2>, "title">;

export function DashboardCard2({
  Actions,
  children,
  className,
  classNameChildren,
  classNameCopy,
  copy,
  headingProps,
  isFullBleed,
  rawChildren,
  title,
  ...cardProps
}: DashboardCardProps) {
  return (
    <Card2
      className={cn("tw:flex-col", "tw:max-md:p-4 tw:max-md:pb-5", "tw:md:p-6", className)}
      {...cardProps}
    >
      {title && (
        <header
          className={cn(
            "tw:flex tw:items-center tw:justify-between",
            "tw:max-md:-mx-4 tw:max-md:-mt-4 tw:max-md:mb-4 tw:max-md:min-h-13 tw:max-md:px-4",
            "tw:md:-mx-6 tw:md:-mt-6 tw:md:mb-6 tw:md:min-h-15 tw:md:p-6",
            "tw:border-b tw:border-stroke-quaternary",
            copy && "tw:flex-wrap tw:gap-2",
          )}
        >
          <Heading2
            as="h2"
            className="tw:max-md:-mb-0.5! tw:md:-mb-1!" // optical alignment
            size={2}
            {...headingProps}
          >
            {title}
          </Heading2>

          {Actions}

          {copy && <p className={cn("body-sm tw:w-full tw:md:pr-[40%]", classNameCopy)}>{copy}</p>}
        </header>
      )}

      {rawChildren && children}
      {!rawChildren && (
        <div className={cn(isFullBleed && "tw:-m-6", classNameChildren)}>{children}</div>
      )}
    </Card2>
  );
}
